// DO NOT EDIT -- generated from fs/services/dx-objects/datatables.proto

import { SpaceAssignment } from './assignments.proto';
import { OrgToOrgDxObjectCopyResponse } from './copy.proto';
import * as accesscontrol from '../../shared/accesscontrol';
import * as metrics from '../../api/metrics';
import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';
import * as visualizationsettings from '../search-settings/visualizationsettings';

export namespace DataTablesPublic {

  export const CreateUnnamedDataTableEndpoint = "/grpc/dx_objects.DataTablesPublic/CreateUnnamedDataTable";
  export function CreateUnnamedDataTable(sender: (req: CreateUnnamedDataTableRequest, endpoint: string) => Promise<{}>, req: CreateUnnamedDataTableRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, CreateUnnamedDataTableEndpoint),
      endpoint: CreateUnnamedDataTableEndpoint
    };
  }

  export const CreateDataTableEndpoint = "/grpc/dx_objects.DataTablesPublic/CreateDataTable";
  export function CreateDataTable(sender: (req: CreateDataTableRequest, endpoint: string) => Promise<CreateDataTableResponse>, req: CreateDataTableRequest): { promise: () => Promise<CreateDataTableResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateDataTableEndpoint),
      endpoint: CreateDataTableEndpoint
    };
  }

  export const UpdateDataTableEndpoint = "/grpc/dx_objects.DataTablesPublic/UpdateDataTable";
  export function UpdateDataTable(sender: (req: UpdateDataTableRequest, endpoint: string) => Promise<UpdateDataTableResponse>, req: UpdateDataTableRequest): { promise: () => Promise<UpdateDataTableResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateDataTableEndpoint),
      endpoint: UpdateDataTableEndpoint
    };
  }

  export const MarkDataTableViewedEndpoint = "/grpc/dx_objects.DataTablesPublic/MarkDataTableViewed";
  export function MarkDataTableViewed(sender: (req: MarkDataTableViewedRequest, endpoint: string) => Promise<{}>, req: MarkDataTableViewedRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, MarkDataTableViewedEndpoint),
      endpoint: MarkDataTableViewedEndpoint
    };
  }

  export const ArchiveDataTableEndpoint = "/grpc/dx_objects.DataTablesPublic/ArchiveDataTable";
  export function ArchiveDataTable(sender: (req: ArchiveDataTableRequest, endpoint: string) => Promise<ArchiveDataTableResponse>, req: ArchiveDataTableRequest): { promise: () => Promise<ArchiveDataTableResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveDataTableEndpoint),
      endpoint: ArchiveDataTableEndpoint
    };
  }

  export const BulkArchiveDataTablesEndpoint = "/grpc/dx_objects.DataTablesPublic/BulkArchiveDataTables";
  export function BulkArchiveDataTables(sender: (req: BulkArchiveDataTablesRequest, endpoint: string) => Promise<BulkArchiveDataTablesResponse>, req: BulkArchiveDataTablesRequest): { promise: () => Promise<BulkArchiveDataTablesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BulkArchiveDataTablesEndpoint),
      endpoint: BulkArchiveDataTablesEndpoint
    };
  }

  export const DuplicateDataTableEndpoint = "/grpc/dx_objects.DataTablesPublic/DuplicateDataTable";
  export function DuplicateDataTable(sender: (req: DuplicateDataTableRequest, endpoint: string) => Promise<DuplicateDataTableResponse>, req: DuplicateDataTableRequest): { promise: () => Promise<DuplicateDataTableResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DuplicateDataTableEndpoint),
      endpoint: DuplicateDataTableEndpoint
    };
  }

  export const StarDataTableEndpoint = "/grpc/dx_objects.DataTablesPublic/StarDataTable";
  export function StarDataTable(sender: (req: StarDataTableRequest, endpoint: string) => Promise<{}>, req: StarDataTableRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, StarDataTableEndpoint),
      endpoint: StarDataTableEndpoint
    };
  }

  export const GetDataTablesAccessEndpoint = "/grpc/dx_objects.DataTablesPublic/GetDataTablesAccess";
  export function GetDataTablesAccess(sender: (req: accesscontrol.CanAccessRequest, endpoint: string) => Promise<accesscontrol.CanAccessResponse>, req: accesscontrol.CanAccessRequest): { promise: () => Promise<accesscontrol.CanAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDataTablesAccessEndpoint),
      endpoint: GetDataTablesAccessEndpoint
    };
  }

  export const CanCreateDataTablesEndpoint = "/grpc/dx_objects.DataTablesPublic/CanCreateDataTables";
  export function CanCreateDataTables(sender: (req: {}, endpoint: string) => Promise<CanCreateDataTablesResponse>, req: {}): { promise: () => Promise<CanCreateDataTablesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CanCreateDataTablesEndpoint),
      endpoint: CanCreateDataTablesEndpoint
    };
  }

  export const GetDataTableEndpoint = "/grpc/dx_objects.DataTablesPublic/GetDataTable";
  export function GetDataTable(sender: (req: GetDataTableRequest, endpoint: string) => Promise<GetDataTableResponse>, req: GetDataTableRequest): { promise: () => Promise<GetDataTableResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDataTableEndpoint),
      endpoint: GetDataTableEndpoint
    };
  }

  export const GetUnnamedDataTableEndpoint = "/grpc/dx_objects.DataTablesPublic/GetUnnamedDataTable";
  export function GetUnnamedDataTable(sender: (req: GetUnnamedDataTableRequest, endpoint: string) => Promise<GetUnnamedDataTableResponse>, req: GetUnnamedDataTableRequest): { promise: () => Promise<GetUnnamedDataTableResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetUnnamedDataTableEndpoint),
      endpoint: GetUnnamedDataTableEndpoint
    };
  }
}

/** DataTablesAdmin provides administrative operations for data tables that are restricted to Fullstory internal users */
export namespace DataTablesAdmin {

  export const CopyDataTablesToOrgEndpoint = "/grpc/dx_objects.DataTablesAdmin/CopyDataTablesToOrg";
  /**
   * CopyDataTablesToOrg copies data tables from one org to another
   * Only accessible to Fullstory internal users
   */
  export function CopyDataTablesToOrg(sender: (req: CopyDataTablesToOrgRequest, endpoint: string) => Promise<OrgToOrgDxObjectCopyResponse>, req: CopyDataTablesToOrgRequest): { promise: () => Promise<OrgToOrgDxObjectCopyResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CopyDataTablesToOrgEndpoint),
      endpoint: CopyDataTablesToOrgEndpoint
    };
  }
}

export interface CreateUnnamedDataTableRequest {
  orgId: string;
  hash: string;
  dataTable: DataTable | null;
}

export interface CreateDataTableRequest {
  orgId: string;
  dataTable: DataTable | null;
  visibility: protoauditstore.Visibility;
  space: SpaceAssignment | null;
}

export interface CreateDataTableResponse {
  dataTable: DataTableDetail | null;
}

export interface UpdateDataTableRequest {
  orgId: string;
  dataTableId: string;
  dataTable: DataTable | null;
  visibility: protoauditstore.Visibility;
  /** If empty, then no space related updates will occur */
  space: SpaceAssignment | null;
}

export interface UpdateDataTableResponse {
  dataTable: DataTableDetail | null;
}

export interface MarkDataTableViewedRequest {
  orgId: string;
  dataTableId: string;
}

export interface ArchiveDataTableRequest {
  orgId: string;
  dataTableId: string;
  /** True to archive, false to unarchive */
  archived: boolean;
}

export interface ArchiveDataTableResponse {
  dataTable: DataTableDetail | null;
}

export interface BulkArchiveDataTablesRequest {
  orgId: string;
  dataTables: ArchiveDataTableRequest[];
}

export interface BulkArchiveDataTablesResponse {
  dataTables: MaybeDataTableDetail[];
}

export interface MaybeDataTableDetail {
  dataTableId: string;
  failed?: boolean;
  dataTable?: DataTableDetail | null;
}

export namespace MaybeDataTableDetail {
  export enum failed_or_data_table {
    failed = 2,
    dataTable = 3
  }

  export function failed_or_data_table_oneof(m: MaybeDataTableDetail): { opt: failed_or_data_table.dataTable, val: DataTableDetail } | { opt: failed_or_data_table.failed, val: boolean } | null {
    if (m.failed != null) { return { opt: failed_or_data_table.failed, val: m.failed } }
    if (m.dataTable != null) { return { opt: failed_or_data_table.dataTable, val: m.dataTable } }
    return null;
  }
}

export interface DuplicateDataTableRequest {
  orgId: string;
  dataTableId: string;
  space: SpaceAssignment | null;
}

export interface DuplicateDataTableResponse {
  dataTable: DataTableDetail | null;
}

export interface StarDataTableRequest {
  orgId: string;
  dataTableId: string;
  /** True to star, false to unstar */
  starred: boolean;
}

export interface DataTable {
  id: string;
  name: string;
  description: string;
  columns: DataTableColumn[];
  dimensions: DataTableDimensions | null;
  settings: visualizationsettings.DataTableSettings | null;
}

/**
 * MetricColumn defines a column in a DataTable that references a metric definition. Currently, this is only a saved
 * metric id, but in the future we may turn this into a oneof and allow unsaved metrics to be defined inline. It is
 * safe and backwards-compatible to turn the metric_id field into a oneof, if we support inline metric definitions in
 * the future.
 */
export interface MetricColumn {
  metricId: string;
}

export enum FunnelMetric {
  FUNNEL_METRIC_UNKNOWN = 0,
  FUNNEL_METRIC_START_USER_COUNT = 1,
  FUNNEL_METRIC_END_USER_COUNT = 2,
  FUNNEL_METRIC_CONVERSION_RATE = 3,
  FUNNEL_METRIC_MEDIAN_TIME_TO_CONVERT = 4,
  /** Only applicable for revenue funnels */
  FUNNEL_METRIC_REVENUE = 5,
  /** Only applicable for revenue funnels */
  FUNNEL_METRIC_AVERAGE_ORDER_VALUE = 6
}

/**
 * FunnelColumn defines a column in a DataTable that references a funnel definition. Currently, this is only a saved
 * funnel id, but in the future we may turn this into a oneof and allow unsaved funnels to be defined inline.
 */
export interface FunnelColumn {
  funnelId: string;
  funnelMetric: FunnelMetric;
}

/**
 * DataTableColumn defines an individual column in a DataTable. This references either a metric or funnel, and
 * may optionally specify a segment to apply to the metric or funnel.
 */
export interface DataTableColumn {
  metric?: MetricColumn | null;
  funnel?: FunnelColumn | null;
}

/**
 * DataTableColumn defines an individual column in a DataTable. This references either a metric or funnel, and
 * may optionally specify a segment to apply to the metric or funnel.
 */
export namespace DataTableColumn {
  export enum column_object {
    metric = 1,
    funnel = 2
  }

  export function column_object_oneof(m: DataTableColumn): { opt: column_object.funnel, val: FunnelColumn } | { opt: column_object.metric, val: MetricColumn } | null {
    if (m.metric != null) { return { opt: column_object.metric, val: m.metric } }
    if (m.funnel != null) { return { opt: column_object.funnel, val: m.funnel } }
    return null;
  }
}

/** DataTableDimension represents a single dimension grouping in the hierarchy. */
export interface DataTableDimension {
  dimension?: DataTableDimension.DataTableDimensionValue | null;
  dimensionGroup?: DataTableDimension.DataTableDimensionGroup | null;
  timeDimension?: DataTableDimension.DataTableTimeDimensionValue | null;
}

/** DataTableDimension represents a single dimension grouping in the hierarchy. */
export namespace DataTableDimension {
  /** A grouping is used for things like city (city + state) or resolution (height + width) which should be treated as combination of multiple dimensions. */
  export interface DataTableDimensionGroup {
    values: metrics.Dimension[];
  }

  export interface DataTableDimensionValue {
    value: metrics.Dimension | null;
  }

  export interface DataTableTimeDimensionValue {
    frequency: visualizationsettings.TrendFrequency;
  }

  export enum dimension_type {
    dimension = 2,
    dimensionGroup = 3,
    timeDimension = 4
  }

  export function dimension_type_oneof(m: DataTableDimension): { opt: dimension_type.dimension, val: DataTableDimension.DataTableDimensionValue } | { opt: dimension_type.dimensionGroup, val: DataTableDimension.DataTableDimensionGroup } | { opt: dimension_type.timeDimension, val: DataTableDimension.DataTableTimeDimensionValue } | null {
    if (m.dimension != null) { return { opt: dimension_type.dimension, val: m.dimension } }
    if (m.dimensionGroup != null) { return { opt: dimension_type.dimensionGroup, val: m.dimensionGroup } }
    if (m.timeDimension != null) { return { opt: dimension_type.timeDimension, val: m.timeDimension } }
    return null;
  }
}

/** NB: This wrapper object is needed since we can't unmarshall a repeated field directly. If/when we store this directly in SQL, this wrapper object can be removed. */
export interface DataTableDimensions {
  dimensions: DataTableDimension[];
}

export interface DataTableRecord {
  dataTable: DataTable | null;
  metadata: protoauditstore.AuditMetadata | null;
}

export interface DataTableDetail {
  dataTable: DataTableRecord | null;
  starred: boolean;
  lastViewed: protobuf.timestamp | null;
}

export interface UnnamedDataTable {
  dataTable: DataTable | null;
}

export interface GetDataTableRequest {
  orgId: string;
  dataTableId: string;
}

export interface GetDataTableResponse {
  dataTable: DataTableDetail | null;
}

export interface GetUnnamedDataTableRequest {
  orgId: string;
  hash: string;
}

export interface GetUnnamedDataTableResponse {
  hash: string;
  dataTable: UnnamedDataTable | null;
}

export interface CanCreateDataTablesResponse {
  canCreate: boolean;
}

/** CopyDataTablesToOrgRequest is used to request copying data tables from a source org to a destination org */
export interface CopyDataTablesToOrgRequest {
  sourceOrgId: string;
  destinationOrgId: string;
  dataTableIds: string[];
  /** Mapping of segment IDs from source to destination */
  segmentIdMappings: { [key: string]: string };
  /** Mapping of metric IDs from source to destination */
  metricIdMappings: { [key: string]: string };
  /** Mapping of funnel IDs from source to destination */
  funnelIdMappings: { [key: string]: string };
}
